import {
  FirebaseStorage,
  getDownloadURL,
  ref,
  uploadBytes,
} from 'firebase/storage';

export async function uploadFile(
  storage: FirebaseStorage,
  file: File,
  path: string
): Promise<string> {
  const fileName = file.name.split('.');
  const fileRef = ref(
    storage,
    `${path}-${new Date().getTime()}.${fileName[fileName.length - 1]}`
  );
  await uploadBytes(fileRef, file);
  const url = await getDownloadURL(fileRef);
  return url;
}
